// src/components/Main.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Main.css';
import Slideshow from './Slideshow';
import FadeInSection from './FadeInSection';
import getCanonicalUrl from '../utils/getCanonicalUrl';

const slideshowImages = [
  "/images/slideshow1.jpeg",
  "/images/slideshow2.jpeg",
  "/images/slideshow3.jpeg"
];

const clickableItems = [
  {
    id: 1,
    title: "極楽寺について",
    image: process.env.PUBLIC_URL + "/images/temple.jpeg",
    link: "#about"
  },
  {
    id: 2,
    title: "供養・ご祈祷",
    image: process.env.PUBLIC_URL + "/images/main_pray.jpeg",
    link: "#prayers"
  },
  {
    id: 3,
    title: "お墓",
    image: process.env.PUBLIC_URL + "/images/main_tombs.jpeg",
    link: "#tombs"
  },
  {
    id: 4,
    title: "お問い合わせ",
    image: process.env.PUBLIC_URL + "/images/main_contact.jpeg",
    link: "#contact"
  }
];

const Main = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [clickedNews, setClickedNews] = useState(new Set());
  const navigate = useNavigate();
  const canonicalUrl = getCanonicalUrl('https://gokurakuji-kinokawa.com/');

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideshowImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const goToEvent = (id) => {
    setClickedNews(prev => new Set(prev).add(id));
    navigate(`/event#${id}`);
    setTimeout(() => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      <Helmet>
        <title>安養山極楽寺 | 和歌山県紀の川市の真言宗寺院</title>
        <meta
          name="description"
          content="高野山真言宗 安養山極楽寺の公式サイト。行事案内、ご供養・永代供養のご相談、霊園・お墓のご案内、アクセス情報をご覧いただけます。"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="安養山極楽寺" />
        <meta property="og:title" content="安養山極楽寺 | 和歌山県紀の川市の真言宗寺院" />
        <meta
          property="og:description"
          content="高野山真言宗 安養山極楽寺の公式サイト。行事案内、ご供養・永代供養、霊園のご紹介など寺院の最新情報をお届けします。"
        />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/slideshow1.jpeg`} />
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <Slideshow />

      <div className="main-content container">
        <FadeInSection>
          <section className="news-section">
            <h2>お知らせ</h2>
            <ul className="news-list">
              <li>
                <strong>2024.11.26（火）</strong><br />
                <span className={`news-title ${clickedNews.has('event-20241126') ? 'clicked' : ''}`} onClick={() => goToEvent('event-20241126')}>
                  動物供養塔&lt;虹&gt;（合祀墓）ペットと一緒に入るクリスタル墓が完成しました
                </span>
              </li>
              <li>
                <strong>2024.11.23（土）</strong><br />
                <span className={`news-title ${clickedNews.has('event-20241123') ? 'clicked' : ''}`} onClick={() => goToEvent('event-20241123')}>
                  極楽寺柴灯大護摩供とマルシェの開催報告
                </span>
              </li>
              <li>
                <strong>2023.11.23（木）</strong><br />
                <span className={`news-title ${clickedNews.has('event-20231123') ? 'clicked' : ''}`} onClick={() => goToEvent('event-20231123')}>
                  極楽寺第十九世住職晋山式と奉納行事のご報告
                </span>
              </li>
            </ul>
          </section>
        </FadeInSection>

        <FadeInSection>
          <section className="grid-section">
            <div className="grid-container">
              {clickableItems.map(item => (
                <a key={item.id} href={item.link} className="grid-item">
                  <img src={item.image} alt={item.title} className="grid-image" />
                  <div className="grid-title">{item.title}</div>
                </a>
              ))}
            </div>
          </section>
        </FadeInSection>

        <FadeInSection>
          <section className="contact-section">
            <div className="contact-info">
              <div className="contact-text">
                <p className="contact-title">高野山真言宗 安養山極楽寺</p>
                <p>〒640-0424 和歌山県紀の川市貴志川町井ノ口106</p>
                <p className="contact-tel">Tel: 0736-64-2329</p>
              </div>
            </div>
            <div className="map-embed">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3299.56429615454!2d135.3179317770325!3d34.20860720945537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6007367578536b11%3A0xd45296a073b2e390!2z5qW15qW95a-6!5e0!3m2!1sja!2sjp!4v1758360809400!5m2!1sja!2sjp"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </section>
        </FadeInSection>
      </div>
    </>
  );
};

export default Main;
